import axios from '@/libs/api.request'

export const getTempList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/template'
  })
}

export const addTemp = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/template'
  })
}


export const check = (params) => {
    return axios.request({
      method: 'get',
      params,
      url: '/template/window'
    })
  }

  
export const editTemp = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/template'
  })
}
export const editTempGoods = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/template/goods'
  })
}

export const delTemp = (id) => {
  return axios.request({
    method: 'delete',
    url: '/template/' + id
  })
}

export const getTempInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/template/' + id
  })
}

export const changeStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/template/status/' + id
  })
}

export const getPlacementList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/placement'
  })
}

export const addPlacement = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/placement'
  })
}

export const editPlacement = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/placement'
  })
}

export const getPlacementInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/placement/' + id
  })
}

export const getPlacementUserList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/placement/list/user'
  })
}

export const getPlacementPlay = (id) => {
  return axios.request({
    method: 'get',
    url: '/placement/play/' + id
  })
}

export const changePlacementStatus = (id) => {
    return axios.request({
      method: 'put',
      url: '/placement/status/' + id
    })
  }